import timezone from 'timezone';
import tzdata from 'moment-timezone/data/packed/latest.json';

timezone.loadData(tzdata);

export default timezone;
